module.exports = __webpack_public_path__ + "fonts/FreightNeoProSemi-Regular.15e82548.otf";